import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setShowingModal } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  id: "",
  source: "content",

  isVisible: false,
  step: 1
};
const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    if (localState.showingModal?.type !== "Vote" || !localState.vote) return INVISIBLE_PROPS;

    return {
      id: props.id,
      source: props.source,

      isVisible: true,
      step: localState.vote.step
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingModal(getEntityRef(props), null))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
